<mat-toolbar class="r-toolbar">
  <button mat-icon-button class="example-icon" [matMenuTriggerFor]="menu"
    aria-label="Example icon-button with menu icon">
    <mat-icon>menu</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item [routerLink]="'/admin/events'">
      <mat-icon>event</mat-icon>
      <span>Events</span>
    </button>
    <button mat-menu-item [routerLink]="'/admin/users'">
      <mat-icon>manage_accounts</mat-icon>
      <span>Users</span>
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="openAbout()">
      <mat-icon>info</mat-icon>
      <span>About</span>
    </button>
  </mat-menu>
  <span>iRegistrator Administration</span>
  <span class="example-spacer"></span>
  <button mat-icon-button class="f-do-not-print" *ngIf='signedIn ; else signIn' (click)="signOut()" routerLink="/admin"
    routerLinkActive="active">
    <mat-icon>logout</mat-icon>
  </button>
  <ng-template #signIn>
    <button mat-icon-button class="f-do-not-print" routerLink="/signin" routerLinkActive="active">
      <mat-icon>login</mat-icon>
    </button>
  </ng-template>
</mat-toolbar>